import { createPinia } from "pinia";
import { initFilters } from "./filter/init";

const pinia = createPinia();
initFilters(pinia);